export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/files-icon.svg?28481aaacbd580bb4501f8040dcf607d";